import { ContentWorkflow, WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import React, { type JSX } from 'react';
import { withRouter } from 'react-router';
import constants from '../../common/constants';
import RouterPaths from '../../common/RouterPaths';
import { withAppContext } from '../../contexts/AppContext';
import BrowserHistory from '../utils/BrowserHistory';
import DraftViewerRole from '../utils/DraftViewerRole';
import AuthorControls from './action-controls/AuthorControls';
import PublishingControls from './action-controls/PublishingControls';
import ContentViewer from './ContentViewer';

class TechWriterContentViewer extends ContentViewer {
  protected isEditingAllowed = true;
  protected showPublicationHistory = true;
  protected showSectionalComments = true;
  protected draftViewerRole = DraftViewerRole.TechWriter;
  protected showLastBarRaiserEvaluation: boolean = true;
  protected showPeerReviewInfo: boolean = true;

  protected showReviewFeedback = (workflow: ContentWorkflow | undefined) => {
    return workflow?.draftState !== WorkflowState.UNMODIFIED;
  };

  protected renderControls(): false | JSX.Element {
    const { workflow, content, validationError, submittingForReview } = this.state;
    const disabled = !!workflow && !!workflow.lock;

    // @ts-expect-error TS18048 - strict migration
    if (workflow.draftState === WorkflowState.REVIEWED) {
      return (
        <PublishingControls
          // @ts-expect-error TS18048 - strict migration
          contentId={workflow.contentId}
          workflow={workflow}
          onActionSuccess={this.navigateToDashboard}
          disabled={disabled}
        />
      );
    } else {
      return (
        <AuthorControls
          // @ts-expect-error TS18048 - strict migration
          contentId={workflow.contentId}
          content={content}
          workflow={workflow}
          disabled={submittingForReview || disabled}
          validationError={validationError}
          onActionSuccess={this.navigateToDashboard}
          loading={submittingForReview}
          readView
        />
      );
    }
  }

  // overrides method in WorkflowView
  protected getBreadcrumbItems(): Array<{ text: string; href: string }> {
    return [
      {
        href: `${RouterPaths.TECH_WRITER_DASHBOARD_NEW}`,
        text: constants.DASHBOARD,
      },
    ];
  }

  protected navigateBack = async () => {
    this.navigateToDashboard();
  };

  private navigateToDashboard = async () => {
    BrowserHistory.push(`${RouterPaths.TECH_WRITER_DASHBOARD_NEW}`);
  };
}

export default withRouter(withAppContext(TechWriterContentViewer));
